// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00dc3247","239":"bc6e44a8","455":"e2a86d1e"}[chunkId] + ".chunk.js";
};